import { render } from "./newStockAllocationForm.vue?vue&type=template&id=178a2abd&scoped=true"
import script from "./newStockAllocationForm.vue?vue&type=script&lang=js"
export * from "./newStockAllocationForm.vue?vue&type=script&lang=js"

import "./newStockAllocationForm.vue?vue&type=style&index=0&id=178a2abd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-178a2abd"]])

export default __exports__